<div class="d-flex flex-column">
    <label>Kontrakt gruppering areal, ha</label>
    <table class="simple-table" [formGroup]="formGroup" raskTableKeyboardNavigation>
        <tbody>
            <tr>
                <td>Slutavv. utan fröträd</td>
                <td>
                    <rask-input-number [useDecimalProcessor]="true" formControlName="arealSlutavvUtanFrotrad">
                    </rask-input-number>
                </td>
            </tr>
            <tr>
                <td>Slutavv. med fröträd</td>
                <td>
                    <rask-input-number [useDecimalProcessor]="true" formControlName="arealSlutavvMedFrotrad">
                    </rask-input-number>
                </td>
            </tr>
            <tr>
                <td>Överståndare</td>
                <td>
                    <rask-input-number [useDecimalProcessor]="true" formControlName="arealOverstandare">
                    </rask-input-number>
                </td>
            </tr>
            <tr>
                <td>Gallring</td>
                <td>
                    <rask-input-number [useDecimalProcessor]="true" formControlName="arealGallring">
                    </rask-input-number>
                </td>
            </tr>
            <tr>
                <td>Övrig avverkning</td>
                <td>
                    <rask-input-number [useDecimalProcessor]="true" formControlName="arealOvrigAvverkning">
                    </rask-input-number>
                </td>
            </tr>
        </tbody>
    </table>
</div>
